var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-object",
      class: _vm.objectVariant === "basic" ? "" : _vm.objectVariant
    },
    [
      _c("a", { attrs: { href: _vm.url } }, [
        _vm.url
          ? _c("div", { staticClass: "c-object__media" }, [
              _c("span", { staticClass: "t-visually-hidden" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _vm.image
                ? _c("img", {
                    staticClass: "c-object__image",
                    attrs: { src: _vm.image, alt: "" }
                  })
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "c-object__content",
            class: { "c-object__content--hasactions": _vm.hasActions }
          },
          [
            _vm.title || _vm.byline
              ? _c("div", { staticClass: "c-object__head" }, [
                  _vm.title
                    ? _c("h2", { staticClass: "c-object__title" }, [
                        _vm._v(_vm._s(_vm.title))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.byline
                    ? _c("span", { staticClass: "c-object__byline" }, [
                        _vm._v(_vm._s(_vm.byline))
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "c-object__body" }, [
              _vm.text
                ? _c("p", { staticClass: "c-object__text" }, [
                    _vm._v(_vm._s(_vm.text))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pros != 0 && _vm.pros && _vm.pros.text
                ? _c(
                    "p",
                    { staticClass: "c-object__pros" },
                    [
                      _c("v-icon", {
                        attrs: {
                          name: "icon-check",
                          size: "s",
                          cssModifiers: "c-icon--success"
                        }
                      }),
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(_vm.pros.text) + "\n\t\t\t\t"
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.info
                ? _c("div", { staticClass: "c-object__info" }, [
                    _c(
                      "ul",
                      { staticClass: "c-object__list" },
                      _vm._l(_vm.info, function(i, index) {
                        return _c("li", { key: index }, [
                          _c("span", { staticClass: "c-object__label" }, [
                            _vm._v(_vm._s(i.displayName) + ":")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "c-object__value" }, [
                            _vm._v(_vm._s(i.displayValue))
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.hasActions
              ? _c(
                  "div",
                  { staticClass: "c-object__action" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "v-object__main-action",
                        attrs: { href: _vm.mainAction.url }
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.mainAction.text))]),
                        _vm._v(" "),
                        _c("v-icon", {
                          attrs: {
                            name: _vm.getIcon(_vm.mainAction.url),
                            size: "xxs"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.secondaryActions, function(button, index) {
                      return _c(
                        "a",
                        {
                          key: index,
                          staticClass: "c-object__action-link",
                          attrs: { href: button.url }
                        },
                        [
                          _c("span", [_vm._v(_vm._s(button.text))]),
                          _vm._v(" "),
                          _c("v-icon", {
                            attrs: {
                              name: _vm.getIcon(_vm.mainAction.url),
                              size: "xxs"
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }